import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type LinkSurfaceProps = {
  to: string;
  children: ReactNode;
  className?: string;
  dark?: boolean;
  arrowLabel?: string;
};

export function LinkSurface({ to, children, className = "", dark = false, arrowLabel = "Explore" }: LinkSurfaceProps) {
  return (
    <Link
      to={to}
      className={`group block rounded-2xl border p-7 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-[3px] focus-visible:ring-offset-bg-primary ${
        dark
          ? "border-white/10 bg-brand-darkSecondary text-brand-darkText hover:border-brand-sage/60"
          : "border-line bg-surface text-ink-primary hover:-translate-y-0.5 hover:border-brand-blue/40 hover:shadow-soft"
      } ${className}`}
    >
      {children}
      <span className={`mt-7 inline-flex items-center gap-2 text-sm font-bold ${dark ? "text-brand-cyan" : "text-brand-blue"}`}>
        {arrowLabel}
        <ArrowRight className="rtl-flip h-4 w-4 transition-transform duration-200 group-hover:translate-x-1 group-focus-visible:translate-x-1" aria-hidden="true" />
      </span>
    </Link>
  );
}
